import { Link } from "react-router-dom";
import { events } from "@/mocks/events";
import EventCard from "@/components/feature/EventCard";
import SectionHeading from "@/components/base/SectionHeading";

export default function LatestEventsSection() {
  const latest = [...events].sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1)).slice(0, 6);

  return (
    <section id="latest" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="w-full">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <SectionHeading
            kicker="近期梳理"
            title="最近整理的事件档案"
            desc="每份档案都包含背景、时间线、相关人物与全程复盘四个部分。"
          />
          <Link
            to="/events"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors duration-200 hover:text-primary-700 cursor-pointer"
          >
            更多事件
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latest.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      </div>
    </section>
  );
}